import { useRouter } from 'next/navigation'
import { useCallback } from 'react'
import { hasAdConsentMacros, replaceAdCachebuster, resolveAdConsentMacros } from './ad-tracking-macros'
import { relativeUrl } from './url'

type AdMediaClickOptions = {
    clickTrackingUrl?: string | null
    clickUrl?: string | null
    gifUrl: string
    navigate: (url: string) => void
}

type AdCtaClickOptions = {
    ctaTrackingUrl?: string | null
    ctaUrl?: string | null
}

export const fireAdTrackingPixel = (trackingUrl?: string | null, label?: string) => {
    if (!trackingUrl) return
    if (label) console.log(label)
    const resolvedUrl = hasAdConsentMacros(trackingUrl) ? resolveAdConsentMacros(trackingUrl) : trackingUrl
    void fetch(replaceAdCachebuster(resolvedUrl), { method: 'GET', mode: 'no-cors', keepalive: true })
}

export const handleAdMediaClick = ({ clickTrackingUrl, clickUrl, gifUrl, navigate }: AdMediaClickOptions) => {
    fireAdTrackingPixel(clickTrackingUrl)

    if (clickUrl) {
        window.open(clickUrl, '_blank', 'noopener,noreferrer')
        return
    }

    navigate(relativeUrl(gifUrl))
}

export const handleAdCtaClick = ({ ctaTrackingUrl, ctaUrl }: AdCtaClickOptions) => {
    fireAdTrackingPixel(ctaTrackingUrl)

    if (ctaUrl) {
        window.open(ctaUrl, '_blank', 'noopener,noreferrer')
    }
}

export const useAdMediaClick = () => {
    const router = useRouter()

    return useCallback(
        (options: Omit<AdMediaClickOptions, 'navigate'>) => {
            handleAdMediaClick({
                ...options,
                navigate: (url) => router.push(url),
            })
        },
        [router]
    )
}
